/* eslint-disable */
import { BadgeGroup } from '@weberus/shared-types/dist/reviews/protobuf-log/module/yanolja_cx_display/badge-group';
/**
 * DO NOT EDIT THIS FILE
 */
import { KinesisTracker } from '@weberus/client-tracker';
import { PriceGroup } from '@weberus/shared-types/dist/reviews/protobuf-log/module/yanolja_cx_display/price-group';
import { ProductGroup } from '@weberus/shared-types/dist/reviews/protobuf-log/module/yanolja_cx_display/product-group';
import { ReviewGroup } from '@weberus/shared-types/dist/reviews/protobuf-log/module/yanolja_cx_display/review-group';

/**
 * PageName: ENTERTAINMENT_HOME
 */
export const EntertainmentHomePageLog = {
  Unspecified: {
    /**
     * 엔터서브홈 진입
     * 스레드 : Line no. 3, 4 / @1, 2
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L5}
     */
    view({}: EntertainmentHomePageLog.Unspecified.View = {}) {
      return KinesisTracker.view('ENTERTAINMENT_HOME', {
        clientEventId: 302,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        eventType: 'EVENT_TYPE_VIEW',
      });
    },
  },

  HeaderButtonBackwardBtn: {
    /**
     * 헤더 뒤로가기 클릭
     * 스레드 : Line no. 6 / 3
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L13}
     */
    click({}: EntertainmentHomePageLog.HeaderButtonBackwardBtn.Click = {}) {
      return KinesisTracker.click('ENTERTAINMENT_HOME', {
        clientEventId: 303,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: 'backwardBtn',
        objectContainer: 'header',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  HeaderButtonSearchBtn: {
    /**
     * 헤더 검색 돋보기 클릭
     * 스레드 : Line no. 8 / 5
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L24}
     */
    click({}: EntertainmentHomePageLog.HeaderButtonSearchBtn.Click = {}) {
      return KinesisTracker.click('ENTERTAINMENT_HOME', {
        clientEventId: 304,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: 'searchBtn',
        objectContainer: 'header',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  HeaderButtonCartBtn: {
    /**
     * 헤더 검색 장바구니 클릭
     * 스레드 : Line no. 7 / 4
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L35}
     */
    click({}: EntertainmentHomePageLog.HeaderButtonCartBtn.Click = {}) {
      return KinesisTracker.click('ENTERTAINMENT_HOME', {
        clientEventId: 305,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: 'cartBtn',
        objectContainer: 'header',
        objectType: 'OBJECT_TYPE_BUTTON',
        eventType: 'EVENT_TYPE_CLICK',
      });
    },
  },

  PromotionBannerRoundedItemId: {
    /**
     * 프로모션 배너 노출
     * 스레드 : Line no. 11 / 7
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L46}
     * EntertainmentPromotionBanner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/subhome/entertainment.proto#L11}
     */
    impression({
      promotionBannerRoundedGroupId,
      promotionBannerRoundedItemTitle,
      deepLinkUri,
      position,
      widgetTargetTitle,
      widgetPosition,
      promotionBannerRoundedItemId,
    }: EntertainmentHomePageLog.PromotionBannerRoundedItemId.Impression) {
      return KinesisTracker.impression('ENTERTAINMENT_HOME', {
        clientEventId: 306,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: promotionBannerRoundedItemId,
        objectContainer: 'promotionBannerRounded',
        objectType: 'OBJECT_TYPE_PROMOTION_BANNER_ROUNDED_ITEM_ID',
        eventType: 'EVENT_TYPE_IMPR',
        promotionBannerRoundedGroupId,
        promotionBannerRoundedItemTitle,
        deepLinkUri,
        position,
        widgetTargetTitle,
        widgetPosition,
      });
    },

    /**
     * 프로모션 배너 클릭
     * 스레드 : Line no. 10 / 6
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L58}
     * EntertainmentPromotionBanner
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/subhome/entertainment.proto#L11}
     */
    click({
      promotionBannerRoundedGroupId,
      promotionBannerRoundedItemTitle,
      deepLinkUri,
      position,
      widgetTargetTitle,
      widgetPosition,
      promotionBannerRoundedItemId,
    }: EntertainmentHomePageLog.PromotionBannerRoundedItemId.Click) {
      return KinesisTracker.click('ENTERTAINMENT_HOME', {
        clientEventId: 307,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: promotionBannerRoundedItemId,
        objectContainer: 'promotionBannerRounded',
        objectType: 'OBJECT_TYPE_PROMOTION_BANNER_ROUNDED_ITEM_ID',
        eventType: 'EVENT_TYPE_CLICK',
        promotionBannerRoundedGroupId,
        promotionBannerRoundedItemTitle,
        deepLinkUri,
        position,
        widgetTargetTitle,
        widgetPosition,
      });
    },
  },

  ThemeStoreItem: {
    /**
     * 테마관 아이템 노출
     * 스레드 : Line no. 14 / 9
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L70}
     * EntertainmentThemeStore
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/subhome/entertainment.proto#L21}
     */
    impression({
      themeStoreId,
      themeStoreItemTitle,
      deepLinkUri,
      position,
      widgetTargetTitle,
      widgetPosition,
      themeStoreItem,
    }: EntertainmentHomePageLog.ThemeStoreItem.Impression) {
      return KinesisTracker.impression('ENTERTAINMENT_HOME', {
        clientEventId: 308,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: themeStoreItem,
        objectContainer: 'themeStore',
        objectType: 'OBJECT_TYPE_THEME_STORE_ITEM',
        eventType: 'EVENT_TYPE_IMPR',
        themeStoreId,
        themeStoreItemTitle,
        deepLinkUri,
        position,
        widgetTargetTitle,
        widgetPosition,
      });
    },

    /**
     * 테마관 아이템 클릭
     * 스레드 : Line no. 13 / 8
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L82}
     * EntertainmentThemeStore
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/subhome/entertainment.proto#L21}
     */
    click({
      themeStoreId,
      themeStoreItemTitle,
      deepLinkUri,
      position,
      widgetTargetTitle,
      widgetPosition,
      themeStoreItem,
    }: EntertainmentHomePageLog.ThemeStoreItem.Click) {
      return KinesisTracker.click('ENTERTAINMENT_HOME', {
        clientEventId: 309,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: themeStoreItem,
        objectContainer: 'themeStore',
        objectType: 'OBJECT_TYPE_THEME_STORE_ITEM',
        eventType: 'EVENT_TYPE_CLICK',
        themeStoreId,
        themeStoreItemTitle,
        deepLinkUri,
        position,
        widgetTargetTitle,
        widgetPosition,
      });
    },
  },

  ProductCurationGridId: {
    /**
     * 큐레이션 위젯 상품 노출
     * 스레드 : Line no. 17 / 12
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L94}
     * EntertainmentCurationGridProduct
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/subhome/entertainment.proto#L43}
     */
    impression({
      deusGroupId,
      widgetTitle,
      widgetTargetTitle,
      widgetPosition,
      widgetTabTitle,
      widgetTabPosition,
      position,
      reviewGroup,
      badgeGroup,
      priceGroup,
      productGroup,
      productCategoryId,
      rentPriceMemberCode,
      stayPriceMemberCode,
      badgeMemberCode,
      priceType,
      globalStayPriceMemberCode,
      productVersion,
      productStatusCode,
      productId,
    }: EntertainmentHomePageLog.ProductCurationGridId.Impression) {
      return KinesisTracker.impression('ENTERTAINMENT_HOME', {
        clientEventId: 310,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: productId,
        objectContainer: 'productCurationGrid',
        objectType: 'OBJECT_TYPE_PRODUCT_ID',
        eventType: 'EVENT_TYPE_IMPR',
        deusGroupId,
        widgetTitle,
        widgetTargetTitle,
        widgetPosition,
        widgetTabTitle,
        widgetTabPosition,
        position,
        reviewGroup,
        badgeGroup,
        priceGroup,
        productGroup,
        productCategoryId,
        rentPriceMemberCode,
        stayPriceMemberCode,
        badgeMemberCode,
        priceType,
        globalStayPriceMemberCode,
        productVersion,
        productStatusCode,
      });
    },

    /**
     * 큐레이션 위젯 상품 클릭
     * 스레드 : Line no. 16 / 10
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L106}
     * EntertainmentCurationGridProduct
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/subhome/entertainment.proto#L43}
     */
    click({
      deusGroupId,
      widgetTitle,
      widgetTargetTitle,
      widgetPosition,
      widgetTabTitle,
      widgetTabPosition,
      position,
      reviewGroup,
      badgeGroup,
      priceGroup,
      productGroup,
      productCategoryId,
      rentPriceMemberCode,
      stayPriceMemberCode,
      badgeMemberCode,
      priceType,
      globalStayPriceMemberCode,
      productVersion,
      productStatusCode,
      productId,
    }: EntertainmentHomePageLog.ProductCurationGridId.Click) {
      return KinesisTracker.click('ENTERTAINMENT_HOME', {
        clientEventId: 311,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: productId,
        objectContainer: 'productCurationGrid',
        objectType: 'OBJECT_TYPE_PRODUCT_ID',
        eventType: 'EVENT_TYPE_CLICK',
        deusGroupId,
        widgetTitle,
        widgetTargetTitle,
        widgetPosition,
        widgetTabTitle,
        widgetTabPosition,
        position,
        reviewGroup,
        badgeGroup,
        priceGroup,
        productGroup,
        productCategoryId,
        rentPriceMemberCode,
        stayPriceMemberCode,
        badgeMemberCode,
        priceType,
        globalStayPriceMemberCode,
        productVersion,
        productStatusCode,
      });
    },
  },

  ProductCurationGridTabBtn: {
    /**
     * 큐레이션 위젯 탭 클릭
     * 스레드 : Line no. 18 / 11
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L118}
     * EntertainmentCurationGrid
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/subhome/entertainment.proto#L31}
     */
    click({
      deusGroupId,
      widgetTitle,
      widgetTargetTitle,
      widgetPosition,
      widgetTabTitle,
      widgetTabPosition,
      position,
    }: EntertainmentHomePageLog.ProductCurationGridTabBtn.Click) {
      return KinesisTracker.click('ENTERTAINMENT_HOME', {
        clientEventId: 312,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: 'tabBtn',
        objectContainer: 'productCurationGrid',
        objectType: 'OBJECT_TYPE_TAB_BTN',
        eventType: 'EVENT_TYPE_CLICK',
        deusGroupId,
        widgetTitle,
        widgetTargetTitle,
        widgetPosition,
        widgetTabTitle,
        widgetTabPosition,
        position,
      });
    },
  },

  QuickCategoryBoardRowItem: {
    /**
     * 엔터 서브홈 - 퀵카테고리 - 노출
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L130}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    impression({ widgetPosition, position, logMeta }: EntertainmentHomePageLog.QuickCategoryBoardRowItem.Impression) {
      return KinesisTracker.impression('ENTERTAINMENT_HOME', {
        clientEventId: 351,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_IMPR',
        widgetPosition,
        position,
        ...logMeta,
      });
    },

    /**
     * 엔터 서브홈 - 퀵카테고리 - 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/sub_home/entertainment/common.txtpb#L143}
     * QuickCategory
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/home.proto#L37}
     */
    click({ widgetPosition, position, logMeta }: EntertainmentHomePageLog.QuickCategoryBoardRowItem.Click) {
      return KinesisTracker.click('ENTERTAINMENT_HOME', {
        clientEventId: 352,
        pageName: 'PAGE_NAME_ENTERTAINMENT_HOME',
        object: 'quickCategoryBoardRowItem',
        objectContainer: 'quickCategory',
        objectType: 'OBJECT_TYPE_QUICK_CATEGORY_BOARD_ROW_ITEM',
        eventType: 'EVENT_TYPE_CLICK',
        widgetPosition,
        position,
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace EntertainmentHomePageLog {
  export namespace Unspecified {
    /**
     * 스레드 : Line no. 3, 4 / @1, 2
     */
    export interface View {}
  }
  export namespace HeaderButtonBackwardBtn {
    /**
     * 스레드 : Line no. 6 / 3
     */
    export interface Click {}
  }
  export namespace HeaderButtonSearchBtn {
    /**
     * 스레드 : Line no. 8 / 5
     */
    export interface Click {}
  }
  export namespace HeaderButtonCartBtn {
    /**
     * 스레드 : Line no. 7 / 4
     */
    export interface Click {}
  }
  export namespace PromotionBannerRoundedItemId {
    /**
     * 스레드 : Line no. 11 / 7
     */
    export interface Impression {
      /* banner id*/
      promotionBannerRoundedGroupId: string;
      /* banner title*/
      promotionBannerRoundedItemTitle: string;
      /* banner link url*/
      deepLinkUri: string;
      /* banner 위치*/
      position: number;
      widgetTargetTitle: string;
      /* widget 위치*/
      widgetPosition: number;
      promotionBannerRoundedItemId: string;
    }

    /**
     * 스레드 : Line no. 10 / 6
     */
    export interface Click {
      /* banner id*/
      promotionBannerRoundedGroupId: string;
      /* banner title*/
      promotionBannerRoundedItemTitle: string;
      /* banner link url*/
      deepLinkUri: string;
      /* banner 위치*/
      position: number;
      widgetTargetTitle: string;
      /* widget 위치*/
      widgetPosition: number;
      promotionBannerRoundedItemId: string;
    }
  }
  export namespace ThemeStoreItem {
    /**
     * 스레드 : Line no. 14 / 9
     */
    export interface Impression {
      /* theme store id*/
      themeStoreId: string;
      /* theme store 명*/
      themeStoreItemTitle: string;
      /* theme store link url*/
      deepLinkUri?: string;
      /* theme store 위치*/
      position: number;
      widgetTargetTitle: string;
      /* widget 위치*/
      widgetPosition: number;
      themeStoreItem: string;
    }

    /**
     * 스레드 : Line no. 13 / 8
     */
    export interface Click {
      /* theme store id*/
      themeStoreId: string;
      /* theme store 명*/
      themeStoreItemTitle: string;
      /* theme store link url*/
      deepLinkUri?: string;
      /* theme store 위치*/
      position: number;
      widgetTargetTitle: string;
      /* widget 위치*/
      widgetPosition: number;
      themeStoreItem: string;
    }
  }
  export namespace ProductCurationGridId {
    /**
     * 스레드 : Line no. 17 / 12
     */
    export interface Impression {
      /* theme store item, &#34;9223090562003566592&#34;, #ydm으로 전환후 대응되는 값이 있다면 해당 값으로 변경*/
      deusGroupId: string;
      /* 위젯 제목, &#34;베트남으로 떠나자!&#34;*/
      widgetTitle: string;
      /* 위젯 Title, &#34;GLOBAL_MKT_1&#34;*/
      widgetTargetTitle: string;
      /* widget 위치, 1*/
      widgetPosition: number;
      /* 위젯 탭 제목, &#34;다낭&#34;*/
      widgetTabTitle: string;
      /* widget tab 순서, 1*/
      widgetTabPosition: number;
      /* ================================== &#34;유닛최적화 기반 logMeta&#34; 로 일괄 적용 되는 부분 : start ==================================*/
      position: number;
      /* 리뷰 정보*/
      reviewGroup: ReviewGroup;
      /* 뱃지 정보*/
      badgeGroup: BadgeGroup;
      /* 가격 정보*/
      priceGroup: PriceGroup;
      /* 상품 정보*/
      productGroup: ProductGroup;
      productCategoryId: string;
      rentPriceMemberCode: string;
      stayPriceMemberCode: string;
      badgeMemberCode: string;
      priceType: string;
      globalStayPriceMemberCode: string;
      /* 상품 버전*/
      productVersion: string;
      /* 상품 상태 코드*/
      productStatusCode: string;
      productId: string;
    }

    /**
     * 스레드 : Line no. 16 / 10
     */
    export interface Click {
      /* theme store item, &#34;9223090562003566592&#34;, #ydm으로 전환후 대응되는 값이 있다면 해당 값으로 변경*/
      deusGroupId: string;
      /* 위젯 제목, &#34;베트남으로 떠나자!&#34;*/
      widgetTitle: string;
      /* 위젯 Title, &#34;GLOBAL_MKT_1&#34;*/
      widgetTargetTitle: string;
      /* widget 위치, 1*/
      widgetPosition: number;
      /* 위젯 탭 제목, &#34;다낭&#34;*/
      widgetTabTitle: string;
      /* widget tab 순서, 1*/
      widgetTabPosition: number;
      /* ================================== &#34;유닛최적화 기반 logMeta&#34; 로 일괄 적용 되는 부분 : start ==================================*/
      position: number;
      /* 리뷰 정보*/
      reviewGroup: ReviewGroup;
      /* 뱃지 정보*/
      badgeGroup: BadgeGroup;
      /* 가격 정보*/
      priceGroup: PriceGroup;
      /* 상품 정보*/
      productGroup: ProductGroup;
      productCategoryId: string;
      rentPriceMemberCode: string;
      stayPriceMemberCode: string;
      badgeMemberCode: string;
      priceType: string;
      globalStayPriceMemberCode: string;
      /* 상품 버전*/
      productVersion: string;
      /* 상품 상태 코드*/
      productStatusCode: string;
      productId: string;
    }
  }
  export namespace ProductCurationGridTabBtn {
    /**
     * 스레드 : Line no. 18 / 11
     */
    export interface Click {
      /* theme store item,*/
      deusGroupId: string;
      /* 위젯 제목, &#34;베트남으로 떠나자!&#34;*/
      widgetTitle: string;
      /* 위젯 Title, &#34;GLOBAL_MKT_1&#34;*/
      widgetTargetTitle: string;
      /* widget 위치, 1*/
      widgetPosition: number;
      /* 위젯 탭 제목, &#34;다낭&#34;*/
      widgetTabTitle: string;
      /* widget tab 순서, 1*/
      widgetTabPosition: number;
      position: string;
    }
  }
  export namespace QuickCategoryBoardRowItem {
    /**
     */
    export interface Impression {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }

    /**
     */
    export interface Click {
      /* 위젯주소 : 페이지 내 위젯 위치*/
      widgetPosition: number;
      /* 위젯 내 상품 위치(순서)*/
      position: number;
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
}
